import { render } from "./tw-menu.vue?vue&type=template&id=2e82965e"
import script from "./tw-menu.vue?vue&type=script&lang=js"
export * from "./tw-menu.vue?vue&type=script&lang=js"
script.render = render

export default script